'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionShopTwo = function ActionShopTwo(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M3 9H1v11c0 1.11.89 2 2 2h14c1.11 0 2-.89 2-2H3V9zm15-4V3c0-1.11-.89-2-2-2h-4c-1.11 0-2 .89-2 2v2H5v11c0 1.11.89 2 2 2h14c1.11 0 2-.89 2-2V5h-5zm-6-2h4v2h-4V3zm0 12V8l5.5 3-5.5 4z' })
  );
};
ActionShopTwo = (0, _pure2.default)(ActionShopTwo);
ActionShopTwo.displayName = 'ActionShopTwo';
ActionShopTwo.muiName = 'SvgIcon';

exports.default = ActionShopTwo;


/*****************
 ** WEBPACK FOOTER
 ** ./~/material-ui/svg-icons/action/shop-two.js
 ** module id = 1583
 ** module chunks = 0
 **/